export default "__VITE_ASSET__BEX_kJdr__"